import Model from 'flarum/common/Model';
/**
 * An immutable snapshot of an article's title and body, taken each time the
 * article is edited. Revisions are read-only history.
 */
export default class WikiRevision extends Model {
  title = (() => Model.attribute('title'))();
  content = (() => Model.attribute('content'))();
  contentHtml = (() => Model.attribute('contentHtml'))();
  summary = (() => Model.attribute('summary'))();
  createdAt = (() => Model.attribute('createdAt', Model.transformDate))();
  user = (() => Model.hasOne('user'))();
  article = (() => Model.hasOne('article'))();
}
flarum.reg.add('linkrobins-wiki', 'common/models/WikiRevision', WikiRevision);